import { render, staticRenderFns } from "./MultipleStringInput.vue?vue&type=template&id=b97bda4c&scoped=true&"
import script from "./MultipleStringInput.vue?vue&type=script&lang=js&"
export * from "./MultipleStringInput.vue?vue&type=script&lang=js&"
import style0 from "./MultipleStringInput.vue?vue&type=style&index=0&id=b97bda4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97bda4c",
  null
  
)

export default component.exports